const InitialStateLeJourney = {
  previousScreen: 'NO_SCREEN_TO_SHOW',
  currentScreen: 'WELCOME_BS_SCREEN',
  globalOverlayLoader: false,
  screenConstHistory: [],
  selectedBankObj: {},
  noOfStatement: 3,
  bankStatementPassword: '',
  comingBackFromPerfiosFlag: false,
  journeyTypeEnum: '',
  monthlyStatementErr: {
    isError: false,
    errorMsg: '',
  },
  ackScreen: {
    statusCode: '',
    statusMsg: '',
    statusDes: '',
    bgImg: '',
    fiboLottieJSON: '',
  },
  getBankAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  getPrefferedOptionsAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  perfiosOnlineBankingAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bsOnlineTxnAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bsVerifyTxnAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  saveBsDocUploadAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  s3FileUploadAPICall: {
    uploadFileResponses: [null, null, null, null],
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export default InitialStateLeJourney;
